/**
 * 反转数组，与 Array.reverse 不同的是，该函数不会修改原数组而返回新数组
 * @param arr {Array}
 * @return {Array}
 */
export function reverseArray<T>(arr: T[]): T[] {
  if (!Array.isArray(arr)) return arr;

  let index = arr.length - 1;
  const result: T[] = [];

  while (index >= 0) {
    result.push(arr[index]);
    index--;
  }
  return result;
}

/**
 * 分组
 * @param arr {Array}
 * @param iteratee {Function}
 * @return {*}
 */
export function groupBy<T>(arr: T[], iteratee: Function): {[k: string]: T[]} {
  let key: string;
  return arr.reduce((prev, value) => {
    key = iteratee(value);
    if (prev.hasOwnProperty(key)) {
      prev[key].push(value);
    } else {
      prev[key] = [value];
    }
    return prev;
  }, {});
}
